// eslint-disable-next-line import-x/no-extraneous-dependencies
import { parseAbsolute, startOfMonth, toCalendarDate } from '@internationalized/date';
import { TFunction } from 'i18next';
import React from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '../../app/AuthorizationProvider';
import { PATH_MY_SCHEDULE_MONTHLY } from '../../router/routes';

interface MyScheduleTypeSwitcherProps {
  date?: Date;
  t: TFunction;
}

// TODO: For weekly view only in old design. Once weekly view scene will be re-designed this file can be deleted
export const MyScheduleTypeSwitcherOld: React.FC<MyScheduleTypeSwitcherProps> = ({ date, t }) => {
  const { timezone } = useAuth();

  const zonedDateTime = date ? parseAbsolute(date.toISOString(), timezone) : null;
  const defaultDate = zonedDateTime ? startOfMonth(toCalendarDate(zonedDateTime)) : '';
  const queryDate = date ? `date=${defaultDate.toString()}` : '';

  const detailViewPathname = PATH_MY_SCHEDULE_MONTHLY;
  const buttonText = t(`schedule.mySchedule.monthlyView`);

  return (
    <Link
      to={{ pathname: detailViewPathname, search: queryDate }}
      className="btn btn-primary schedule-type-switcher__button"
      data-test-id="schedule-type-switcher-button"
      title={buttonText}
    >
      {buttonText}
    </Link>
  );
};
